module.exports = __webpack_public_path__ + "media/images/guide-thumb-3-5dfdd061063d40f6a2a527e50b19a7ca.png";